// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"246b75d0","513":"9248aa20","703":"024326f2"}[chunkId] + ".chunk.js";
};